import { useRef, useState } from 'react'
import styled from 'styled-components'
import { useElementSize } from 'usehooks-ts'
const COLLAPSED_MAX_HEIGHT = 300
const Answer = ({
  answerText,
  gptBadge,
}: {
  answerText: string
  gptBadge?: string
}) => {
  const [squareRef, { width, height }] = useElementSize()
  const [isExpanded, setIsExpanded] = useState(false)
  const isExpandable = height - 100 > COLLAPSED_MAX_HEIGHT
  const wrapperRef = useRef<HTMLDivElement>(null)
  console.log('height', height, { isExpandable })

  return (
    <AnswerWrapper
      isCollapsed={!isExpanded && isExpandable}
      heightOfText={height}
      collapsedMaxHeight={COLLAPSED_MAX_HEIGHT}
      ref={wrapperRef}
    >
      <AnswerText
        ref={squareRef}
        dangerouslySetInnerHTML={{
          __html: answerText,
        }}
      />
      {isExpandable && (
        <ExpandButton
          onClick={() => {
            // scroll to the top of the wrapper
            if (isExpanded && wrapperRef.current) {
              console.log('scrolling to wrapper')
              wrapperRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              })
            }
            setIsExpanded(!isExpanded)
          }}
          isExpanded={isExpanded}
        >
          <IconWrapper isExpanded={isExpanded}>
            <svg
              width='14px'
              height='14px'
              viewBox='0 0 12 12'
              xmlns='http://www.w3.org/2000/svg'
            >
              <polyline
                fill='none'
                strokeWidth='1.5'
                points='2 4 6.2560339 8.2560339 10.5120678 4'
              ></polyline>
            </svg>
          </IconWrapper>
          {isExpanded ? 'weniger anzeigen' : 'mehr anzeigen'}
        </ExpandButton>
      )}
      {gptBadge && <ModelBadge>{gptBadge}</ModelBadge>}
    </AnswerWrapper>
  )
}
export default Answer
const AnswerText = styled.div`
  padding: 1.5em 1em;
  overflow: hidden;
`
const AnswerWrapper = styled.div<{
  isCollapsed?: boolean
  heightOfText?: number
  collapsedMaxHeight: number
}>`
  transition: all 0.3s ease-in-out;
  white-space: pre-wrap;
  max-width: 100%;
  width: 100%;
  font-family: 'Courier New', Courier, monospace;
  background-color: rgba(127, 127, 127, 0.1);
  /* padding: .5em; */
  margin-top: 1em;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  transition: all 0.6s ease-in-out;
  max-height: ${({ isCollapsed, heightOfText, collapsedMaxHeight }) =>
    isCollapsed ? collapsedMaxHeight + 'px' : heightOfText + 'px' ?? '3000px'};
  ${AnswerText} {
    mask-image: ${({ isCollapsed, collapsedMaxHeight }) =>
      isCollapsed
        ? `linear-gradient(to bottom, black ${
            collapsedMaxHeight - 100
          }px, transparent ${collapsedMaxHeight}px)`
        : ''};
  }
`

const ModelBadge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1em;
  font-weight: 600;
  line-height: 1.5em;
  padding: 0em 0.75em;
  background-color: var(--site-background);
  font-family: var(--font-sans-serif);
  border-radius: 0px 5px 0px 5px;
  box-shadow: -4px 4px 10px rgba(0, 0, 0, 0.05);
`
const ExpandButton = styled.button<{ isExpanded?: boolean }>`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 3px);
  padding: 0.5em 1em;
  padding-bottom: calc(3px + 0.5em);
  background-color: var(--yellow-main);
  /* background-color: var(--site-background); */
  font-family: var(--font-sans-serif);
  border-radius: 5px 5px 0px 0px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
  transition: all 0.2s ease-in-out;
  font-size: ${({ isExpanded }) => (isExpanded ? '.8em' : '1em')};
  font-weight: 500;
  line-height: 1em;
  border: none;
  z-index: 4;
  color: var(--brandblue-main);
  white-space: nowrap;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  opacity: 0.8;

  &:hover {
    opacity: 1;
    transform: translate(-50%, 0px);
  }
`
const IconWrapper = styled.div<{ isExpanded?: boolean }>`
  svg {
    stroke: currentColor;
    transition: all 0.3s ease-in-out;

    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
  }
  padding-right: 0.5em;
  display: flex;
  align-items: center;
`
